/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M512 42.667A469.333 469.333 0 10981.333 512 469.333 469.333 0 00512 42.667zm0 864A394.667 394.667 0 11906.667 512 395.147 395.147 0 01512 906.667z" _fill="#8a8a8a"/><path pid="1" d="M670.4 300.8L515.733 455.467a5.333 5.333 0 01-7.573 0L353.493 300.8a5.333 5.333 0 00-7.52 0L300.8 346.08a5.333 5.333 0 000 7.52l154.667 154.667a5.333 5.333 0 010 7.573L300.8 670.507a5.333 5.333 0 000 7.52l45.28 45.28a5.333 5.333 0 007.52 0L508.267 568.64a5.333 5.333 0 017.573 0l154.667 154.667a5.333 5.333 0 007.52 0l45.28-45.28a5.333 5.333 0 000-7.52L568.64 515.84a5.333 5.333 0 010-7.573L723.307 353.6a5.333 5.333 0 000-7.52l-45.28-45.28a5.333 5.333 0 00-7.627 0z" _fill="#8a8a8a"/>'
  }
})
